<template>
  <form-group label="Status do Estoque" :columns="6">
    <select v-model="filters.status" class="form-select">
      <option :value=null>Todos</option>
      <option v-for="status in productStockStatuses" :value="status" :key="status">{{ $t(status).label }}</option>
    </select>
  </form-group>
</template>

<script>
  import api from '@/api'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      productStockStatuses: [],
      filters: {
        status: null
      }
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    mounted () {
      api.getProductStockStatuses(this.module.type, this.module.identifier)
        .then(productStatuses => {
          this.productStockStatuses = productStatuses
          let index = this.productStockStatuses.indexOf('queue')

          if (index !== -1) {
            this.productStockStatuses.splice(index, 1)
          }
        })
        .catch(() => (this.productStockStatuses = []))
    },
    watch: {
      'filters.status' () {
        this.$emit('change', this.filters)
      }
    },
    components: {
      FormGroup
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// StockStatus.vue?22326b42